import React from "react";
import { motion } from "framer-motion";
import { MaskLines } from "./Reveal";
import { useI18n } from "../i18n";

export default function PageHero({ label, title, image, alt }) {
  return (
    <section className="relative pt-40 pb-24 md:pt-52 md:pb-32 bg-[#062029] overflow-hidden grain" data-testid="page-hero">
      {image && (
        <>
          <img src={image} alt={alt || ""} className="absolute inset-0 w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-[#062029]/70" />
        </>
      )}
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} className="label text-[#C5A880] mb-8">
          {label}
        </motion.p>
        <h1 className="font-serif-display text-[#F7F5F0] text-4xl sm:text-6xl lg:text-7xl leading-[1.02] max-w-4xl">
          <MaskLines lines={Array.isArray(title) ? title : [title]} delay={0.2} />
        </h1>
      </div>
    </section>
  );
}
